<section class="bg-white pb-7">
  <div #component class="centered-with-padding px-2.5 pb-5 pt-2.5 desk:py-0">
    <div class="-mt-px mr-[-10px] flex h-[50px] justify-end desk:m-0 desk:items-center">
      <app-svg (click)="onClose()" [width]="16" class="cursor-pointer" src="assets/icons/close.svg" />
    </div>
    @if (data.title; as title) {
      <div class="desk:mt-20">
        <app-title [title]="title" class="text-balance text-center supports-[text-wrap:pretty]:text-pretty" size="h1" />
      </div>
    }
    @if (data.subtitle; as subtitle) {
      <p class="pt-4 text-center">{{ subtitle }}</p>
    }
    <div class="grid grid-cols-1 justify-center gap-y-5 desk:mt-20 desk:grid-cols-[427px_307px] desk:gap-x-10">
      @if (slotSelected() && storeSelected()) {
        <div class="mt-9 desk:mt-0">
          <app-appointment-details
            [fullHeight]="true"
            [slotSelected]="slotSelected()!"
            [storeSelected]="storeSelected()!" />
        </div>
      }
      @let answerOptions = data.answerOptions;
      @if (answerOptions.length > 0) {
        @if (isSubmitted()) {
          <div class="flex flex-col items-center justify-center gap-y-5 px-5 py-10 desk:px-0">
            <div class="text-center text-[20px] font-bold">
              {{ "COMPONENT.CONFIRMATION-RDV.THANK_YOU_RESPONSE" | translate }}
            </div>
          </div>
        } @else {
          <div class="flex flex-col gap-y-5 px-5 desk:px-0">
            <div class="font-bold">{{ data.questionText }}</div>
            <ul class="flex flex-col gap-y-2.5">
              @for (option of answerOptions; track option.key) {
                @let isSelected = answer() !== null && answer()!.key === option.key;
                @let isNotSelected = answer() !== null && answer()!.key !== option.key;
                @let isNothingSelected = answer() === null;
                <li
                  (click)="onAnswerSelected(option)"
                  [ngClass]="{ 'bg-purple': isSelected, 'bg-anis': isNothingSelected, 'bg-gray': isNotSelected }"
                  class="drop-shadow-custom flex h-9 cursor-pointer select-none items-center justify-center rounded-[10px] px-6 text-center font-bold">
                  {{ option.label }}
                </li>
              }
            </ul>
            <div class="flex px-5 desk:pb-0.5">
              <app-button
                (onButtonClick)="onSubmit()"
                [buttonDisabled]="answer() === null"
                [isFullWidth]="true"
                [isLoading]="isSending()"
                [label]="'ACTION.VALIDATE' | translate" />
            </div>
          </div>
        }
      }
    </div>
  </div>
</section>
